<template>
  <vv-screen-wrapper>
    <div class="screen-container">
      <quiz-progress-bar />

      <template v-if="step === 'question'">
        <h1 class="question-title">{{ question }}</h1>

        <vv-radio
          v-for="(radio, index) in choices"
          name="radios"
          :key="radio.value"
          :value="index"
          :label="radio.label"
          v-model.number="radioResponse"
        />

        <div class="cta">
          <vv-button @click="goToResponse" :disabled="radioResponse === null">
            {{ $t('quiz.discoverResponse') }}
          </vv-button>
        </div>
      </template>

      <single-response v-if="step === 'response'" @next="nextQuestion" />
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { VvButton, VvRadio, VvScreenWrapper } from '@/components/common'
import QuizProgressBar from './QuizProgressBar'
import SingleResponse from './responses/SingleResponse'
import { NEXT_QUESTION, RESPONSE } from '@/store/modules/quiz/types'

export default {
  name: 'Single',
  components: { QuizProgressBar, SingleResponse, VvButton, VvRadio, VvScreenWrapper },
  props: {
    choices: Array,
    expectedResponse: Object,
    explanation: Object,
    question: String
  },
  data: () => ({
    radioResponse: null,
    step: 'question'
  }),
  methods: {
    goToResponse() {
      this.$store.dispatch(RESPONSE, { choice: this.radioResponse })
      this.step = 'response'
    },
    nextQuestion() {
      this.$store.dispatch(NEXT_QUESTION)
      this.reset()
    },
    // we reset the component because if the same type of question comes twice in a row
    // the component won't change and we'll stay on the response
    reset() {
      this.step = 'question'
      this.radioResponse = null
    }
  }
}
</script>
